import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import PictureAsPdf from '@mui/icons-material/PictureAsPdf';
import jsPDF from 'jspdf';
import CircularProgress from '@mui/material/CircularProgress';
import {
  getCPU,
  getDisponibilidad,
  getDisponibilidadPromedio,
  getComparativo,
  getInmuebles,
  getDispositivos,
  getAnchoBanda,
} from '../../../api/reportes';
import imageSat from '../../../shared-components/satImage';
import imageBest from '../../../shared-components/imageBest';

const endpoints = [
  { name: 'Disponibilidad Fisica por dispositivo', endpoint: getDisponibilidad },
  { name: 'Reporte Utilización de ancho de banda por Dispositivo', endpoint: getAnchoBanda },
  { name: 'Utilización de Recursos CPU y Memoria por dispositivo', endpoint: getCPU },
  {
    name: 'Reporte de disponibilidad promedio de los enlaces WAN y distribución de las disponibilidades de la red en categorías por colores',
    endpoint: getDisponibilidadPromedio,
  },
  { name: 'Comparativo de ancho de banda', endpoint: getComparativo },
  { name: 'Cantidad de inmuebles administrados por el proveedor', endpoint: getInmuebles },
  { name: 'Cantidad de dispositivos desplegados', endpoint: getDispositivos },
];

const ExportPdfDocument = (fileName) => {
  const [isLoading, setIsLoading] = React.useState(false);

  // let keys =[]
  // let data=[]

  const endpointRes = endpoints.find((item) => item.name === fileName.fileName);

  // if (endpointRes) {
  //   endpointRes.endpoint()
  //     .then(resultado => {

  //       data = resultado
  //       const object1 = resultado[0]
  //       keys = Object.keys(object1)

  //     })
  //     .catch(error => {
  //       console.error(error);
  //     });
  // }
  const exportToPDF = (file, data, keys) => {
    // eslint-disable-next-line new-cap
    const doc = new jsPDF({
      orientation: 'l',
      unit: 'pt',
      format: 'a4',
    });

    doc.addImage(imageSat, 'png', 80, 78, 220, 80);
    doc.setFontSize(22);
    doc.setTextColor(255, 255, 255);
    doc.setDrawColor(0);
    doc.setFillColor(26, 102, 11);
    doc.rect(30, 180, 580, 220, 'F');

    const lines = doc.splitTextToSize(file, 550);
    doc.text(50, 280, lines);

    const pageDimensions = {
      height: 595.28,
      width: 841.89,
    };
    const pageMargin = 50;

    doc.addPage();
    doc.addImage(imageBest, 'png', 40, 10, 80, 80);
    doc.setFontSize(16);
    doc.setTextColor(0, 0, 0);
    const lineTitle = doc.splitTextToSize(file, 450);
    doc.text(160, 40, lineTitle);
    doc.addImage(imageSat, 'png', 650, 20, 150, 50);
    const liveArea = {
      width: pageDimensions.width - pageMargin,
      height: pageDimensions.height - pageMargin,
    };

    const padding = 15;

    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);

    const xPositions = [];

    keys.forEach((text, index) => {
      let heading = '';
      const partes = text.split(/(?=[A-Z])/);
      partes.forEach((part) => {
        heading = `${heading} ${part.toUpperCase()}`;
      });
      // If you decide to add xPos to the header mappings this will fire
      // eslint-disable-next-line no-prototype-builtins
      if (heading.hasOwnProperty('xPos')) {
        doc.text(String(heading), heading.xPos, pageMargin);
        xPositions.push(heading.xPos);
      } else {
        // get x position for heading
        const xPositionForCurrentHeader = pageMargin + index * (liveArea.width / keys.length);
        console.log(xPositionForCurrentHeader);
        // need to position our text within our live area
        const yPositionForHeaders = pageMargin + 50;
        doc.text(
          String(heading),
          // eslint-disable-next-line no-nested-ternary
          index === 0 ? xPositionForCurrentHeader - 5 : index === 1 ? xPositionForCurrentHeader - 10 : xPositionForCurrentHeader + padding,
          yPositionForHeaders
        );

        // Push x position of current header to xPositions array
        xPositions.push(
          // eslint-disable-next-line no-nested-ternary
          index === 0 ? xPositionForCurrentHeader - 5 : index === 1 ? xPositionForCurrentHeader - 10 : xPositionForCurrentHeader + padding
        );
      }
    });

    doc.line(pageMargin, pageMargin + 53.5, liveArea.width, pageMargin + 53.5);

    const baseYPosForRows = pageMargin + padding + 53; // NEW CODE
    let nextYPos = baseYPosForRows;

    data.forEach((row, rIndex) => {
      // Here we are going to collect all columns potential max heights (below)
      // Before we determine the nextYPosition we have to grab the tallest value
      // and add that to the previous height.
      const rowHeights = [];
      /*
       *
       * Row styles go here (lines, images, shapes)
       *
       * */

      // COLUMNS
      keys.forEach((column, colIndex) => {
        // Using the .splitTextToSize method will take a
        // string and a width parameter. It will return an array of strings.
        const longText = doc.splitTextToSize(String(row[column]), xPositions[colIndex] - xPositions[colIndex !== 0 && colIndex - 1]);

        // To get row height, we will use the .getLineHeight method
        // This method returns a line height based on set text
        // size for the document. Multiplied by the array length, your
        // value should be at minimum a standard line of text, OR at
        // maximum the amount of lines of text by line height
        const rowHeight = longText.length * doc.getLineHeight();

        // We need to push this height value to the array of heights for
        // the row (above)
        rowHeights.push(rowHeight);

        /*
         *
         *  Column styles go here (lines, images, shapes)
         *
         * */

        doc.text(longText, xPositions[colIndex], nextYPos);
      });

      // Here's the accumulator expression to inform the next row start point
      nextYPos = nextYPos + padding + Math.max(...rowHeights, 30);

      // When generating looped data, you may need to add pages manually.
      // The good thing is that we've defined our live area boundaries,
      // and can add a new page when our yPosition exceeds them. We need
      // to take some care to reset the yPosition because if you don't:
      // the yPosition will persist to the next page, and more than likely
      // disappear from view as your yPosition grows.
      if (nextYPos > liveArea.height) {
        doc.addPage();
        nextYPos = baseYPosForRows;
      }
    });

    doc.save(`${file}.pdf`);
  };

  const handleButtonClick = async () => {
    setIsLoading(true);
    try {
      if (endpointRes) {
        const dataResults = await endpointRes.endpoint();
        const object1 = dataResults[0];
        const keys = Object.keys(object1);
        exportToPDF(fileName.fileName, dataResults, keys);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <CircularProgress size={30} sx={{ color: 'white' }} />}
      {!isLoading && (
        <IconButton aria-label="delete" onClick={handleButtonClick}>
          <PictureAsPdf />
        </IconButton>
      )}
    </>
  );
};

export default ExportPdfDocument;
